import type { NovelItem } from '@app/_proto/Protos/novels';
import { createContext, useContext } from 'react';
import { create, useStore } from 'zustand';

type AppStore = {
    currentNovel?: NovelItem | undefined;
    layoutOptions: Record<string, any>;
};

type AppStoreActions = {
    setCurrentNovel: (novel: NovelItem) => void;
    setLayoutOptions: (options: Record<string, any>) => void;
};

const createAppStore = (initialOptions: AppStore) => {
    const DEFAULT_PROPS: AppStore = {
        currentNovel: {} as NovelItem,
        layoutOptions: {},
    };

    return create<AppStore & AppStoreActions>(set => ({
        ...DEFAULT_PROPS,
        ...initialOptions,
        setCurrentNovel: (novel: NovelItem) => set({ currentNovel: novel }),
        setLayoutOptions: (options: Record<string, any>) => set({ layoutOptions: options }),
    }));
};

const AppStoreContext = createContext<ReturnType<typeof createAppStore> | null>(null);

const useAppStore = <T>(selector: (state: AppStore & AppStoreActions) => T) =>
    useStore(useContext(AppStoreContext)!, selector);

export { AppStoreContext, createAppStore };

export default useAppStore;
